<div *ngIf="!menu" class="menu-holder hide-print">
  <div class="d-flex flex-row flex-wrap">
    <div class="flex-25 d-flex flex-row">
      <img [src]="settings?.holdingImage?.medium" alt="Menu Waiting" />
    </div>
    <div class="flex-50 d-flex flex-row">
      <span>Loading Mega Menu</span>
    </div>
    <div class="flex-25 d-flex flex-row">
      <img [src]="settings?.holdingImage?.medium" alt="Menu Waiting" />
    </div>
  </div>
</div>
<mat-toolbar *ngIf="menu" class="top-navbar hide-print justify-content-end align-items-center">
  <ng-container *ngFor="let topLevelItem of menu.items">
    <ng-container *ngIf="!topLevelItem.children || topLevelItem.children.length === 0">
      <button mat-button aria-label="Top Level Navigation" [name]="topLevelItem.name" [routerLink]="topLevelItem.link" routerLinkActive="horizontal-active-link" [routerLinkActiveOptions]="{exact:false}" class="top-level {{topLevelItem.cssClass}}">
        {{topLevelItem.name}}
      </button>
    </ng-container>
    <ng-container *ngIf="topLevelItem.children && topLevelItem.children.length > 0">
      <app-menu-mega [mega]="true" [clickFix]="true" [rollOver]="false" [itemName]="topLevelItem.name">
        <button mat-button trigger class="top-level {{topLevelItem.cssClass}} {{router?.url?.indexOf(topLevelItem.link) === 0 ? 'horizontal-active-link' : ''}}">
          {{topLevelItem.name}}
        </button>
        <div content class="d-flex flex-row flex-wrap menu-container">
          <div class="flex-50 d-flex flex-row flex-wrap">
            <div *ngFor="let secondLevelItem of topLevelItem.children" class="second-level {{secondLevelItem.cssClass}} flex-33">
              <a mat-menu-item aria-role="menuitem" [routerLink]="secondLevelItem.link">{{secondLevelItem.name}}</a>
              <ng-container *ngIf="secondLevelItem.children && secondLevelItem.children.length > 0">
                <ng-container *ngFor="let thirdLevelItem of secondLevelItem.children">
                  <a mat-menu-item [routerLink]="thirdLevelItem.link" [class]="'third-level ' + thirdLevelItem.cssClass">{{thirdLevelItem.name}}</a>
                </ng-container>
              </ng-container>
            </div>
          </div>
          <div class="flex-50 d-flex flex-row flex-wrap">
            <app-topic topicSlug="meinl-sonic-energy-mega-menu"></app-topic>
          </div>
        </div>
      </app-menu-mega>
    </ng-container>
  </ng-container>
</mat-toolbar>
